(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collectt"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function addToCart(variantId, btn, card) {
    if (!variantId || btn.disabled) return;
    var origHTML = btn.innerHTML;
    var origStyle = btn.getAttribute('style') || '';
    btn.disabled = true;
    btn.classList.add('jcg-loading');
    btn.innerHTML = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke-dasharray="56.5" stroke-dashoffset="56.5"><animate attributeName="stroke-dashoffset" values="56.5;0" dur="0.6s" repeatCount="indefinite"/></circle></svg><span>···</span>';

    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
    .then(function (item) {
      btn.classList.remove('jcg-loading');
      btn.innerHTML = '<svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M5 13l4 4L19 7"/></svg><span>Añadido</span>';
      btn.style.cssText = 'background:#3a3a4a;color:#fff;border-color:#5a5a6e;';
      if (card) card.classList.add('jcg-added');
      refreshCart(item);
      setTimeout(function () { btn.innerHTML = origHTML; btn.setAttribute('style', origStyle); btn.disabled = false; if (card) card.classList.remove('jcg-added'); }, 2600);
    })
    .catch(function () {
      btn.classList.remove('jcg-loading'); btn.innerHTML = origHTML; btn.setAttribute('style', origStyle); btn.disabled = false;
      var form = document.createElement('form'); form.method = 'POST'; form.action = '/cart/add'; form.style.display = 'none';
      var idInput = document.createElement('input'); idInput.type = 'hidden'; idInput.name = 'id'; idInput.value = variantId;
      var qtyInput = document.createElement('input'); qtyInput.type = 'hidden'; qtyInput.name = 'quantity'; qtyInput.value = '1';
      form.appendChild(idInput); form.appendChild(qtyInput); document.body.appendChild(form); form.submit();
    });
  }

  function refreshCart(item) {
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var count = cart.item_count || 0;
      document.querySelectorAll('[data-cart-count], .cart-count, .cart__count, .header__cart-count, #cart-count, .js-cart-count, .cart-icon-bubble').forEach(function (el) {
        el.textContent = count; el.setAttribute('data-cart-count', count); if (count > 0) el.removeAttribute('hidden');
      });
      document.dispatchEvent(new CustomEvent('cart:refresh',     { bubbles: true, detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:update',      { bubbles: true, detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('theme:cart:open',  { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:open',        { bubbles: true }));
      document.dispatchEvent(new CustomEvent('drawer:open-cart', { bubbles: true }));
      var cartNotification = document.querySelector('cart-notification, cart-drawer');
      if (cartNotification && typeof cartNotification.renderContents === 'function') cartNotification.renderContents({ items: [item] });
      document.body.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { product: item } }));
    })
    .catch(function () {
      document.dispatchEvent(new CustomEvent('cart:refresh',    { bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));
    });
  }

  function sparkle(el, x, y) {
    var fl = Object.assign(document.createElement('div'), { className: 'jcg-flash' }); el.appendChild(fl);
    var rp = Object.assign(document.createElement('div'), { className: 'jcg-ripple' }); rp.style.cssText = 'left:' + x + 'px;top:' + y + 'px;width:36px;height:36px;'; el.appendChild(rp);
    var bu = Object.assign(document.createElement('div'), { className: 'jcg-burst' }); bu.style.cssText = 'left:' + x + 'px;top:' + y + 'px;'; el.appendChild(bu);
    bu.appendChild(Object.assign(document.createElement('div'), { className: 'jcg-ring' }));
    for (var i = 0; i < 10; i++) { var r = Object.assign(document.createElement('div'), { className: 'jcg-ray' }); var a = 36*i+(Math.random()*14-7); var l = 18+Math.random()*20; r.style.cssText='--angle:'+a+'deg;--len:'+l+'px;--dur:'+(0.34+Math.random()*0.18)+'s;--reach:'+(l*1.2)+'px;'; bu.appendChild(r); }
    for (var i = 0; i < 8; i++) { var angle=Math.PI*0.25*i+Math.random()*0.4; var dist=22+Math.random()*24; var dd=Object.assign(document.createElement('div'),{className:'jcg-diamond'}); dd.style.cssText='--tx:'+(Math.cos(angle)*dist)+'px;--ty:'+(Math.sin(angle)*dist)+'px;--sz:'+(3.5+Math.random()*4.5)+'px;--dur:'+(0.4+Math.random()*0.25)+'s;'; dd.style.animationDelay=(Math.random()*0.07)+'s'; bu.appendChild(dd); }
    for (var i = 0; i < 12; i++) { var angle=Math.random()*Math.PI*2; var dist=12+Math.random()*32; var dt=Object.assign(document.createElement('div'),{className:'jcg-sparkle-dot'}); dt.style.cssText='--tx:'+(Math.cos(angle)*dist)+'px;--ty:'+(Math.sin(angle)*dist)+'px;--dur:'+(0.3+Math.random()*0.22)+'s;'; dt.style.animationDelay=(Math.random()*0.09)+'s'; bu.appendChild(dt); }
    setTimeout(function () { bu.remove(); rp.remove(); fl.remove(); }, 1200);
  }

  function init(section) {
    if (!section) return;
    section.addEventListener('click', function (e) {
      var btn = e.target.closest('.jcg-cta');
      if (btn) {
        e.stopPropagation();
        var variantId = btn.getAttribute('data-variant-id');
        var card = btn.closest('.jcg-card');
        addToCart(variantId, btn, card);
        if (card) { var rect = card.getBoundingClientRect(); sparkle(card, e.clientX-rect.left, e.clientY-rect.top); }
        return;
      }
      var card = e.target.closest('.jcg-card:not(.jcg-card--empty)');
      if (card) { var rect = card.getBoundingClientRect(); sparkle(card, e.clientX-rect.left, e.clientY-rect.top); }
    });
    section.addEventListener('touchstart', function (e) {
      var card = e.target.closest('.jcg-card:not(.jcg-card--empty)');
      if (card && !e.target.closest('.jcg-cta')) { var t=e.touches[0]; var rect=card.getBoundingClientRect(); sparkle(card,t.clientX-rect.left,t.clientY-rect.top); }
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.isIntersecting) { entry.target.style.animationPlayState='running'; io.unobserve(entry.target); } });
      }, { threshold: 0.06 });
      section.querySelectorAll('.jcg-card, .jcg-panel').forEach(function (el) { el.style.animationPlayState='paused'; io.observe(el); });
    }
  }

  document.querySelectorAll('.jcg-section').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { var s=e.target.querySelector('.jcg-section'); if (s) init(s); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspots"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var backdrop = document.querySelector('.jhs-backdrop');
  if (!backdrop) {
    backdrop = document.createElement('div');
    backdrop.className = 'jhs-backdrop';
    document.body.appendChild(backdrop);
  }

  function initParallax(section) {
    var wrap = section.querySelector('.jhs__bg-wrap');
    if (!wrap || window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    function onMove(e) {
      var rect = section.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      var cx = (e.clientX / window.innerWidth  - 0.5) * 2;
      var cy = (e.clientY / window.innerHeight - 0.5) * 2;
      wrap.style.transform = 'translate3d(' + (cx * 10) + 'px,' + (cy * 7) + 'px,0)';
    }
    function onLeave() { wrap.style.transform = 'translate3d(0,0,0)'; }
    section.addEventListener('mousemove', onMove,   { passive: true });
    section.addEventListener('mouseleave', onLeave, { passive: true });
  }

  function initHotspots(section) {
    if (!section) return;
    var sectionId = section.dataset.sectionId;
    var openPopup = null;
    var popupMap  = {};

    section.querySelectorAll('.jhs-popup[data-section-ref="' + sectionId + '"]').forEach(function (popup) {
      document.body.appendChild(popup);
      popupMap[popup.dataset.popupId] = popup;
    });

    function positionPopup(popup, pin) {
      var pRect  = pin.getBoundingClientRect();
      var isMob  = window.innerWidth <= 767;
      var pw     = isMob ? 200 : 240;
      var ph     = popup.offsetHeight || 310;
      var gap    = 16;
      var margin = 12;
      var vw     = window.innerWidth;
      var vh     = window.innerHeight;
      var pinCX  = pRect.left + pRect.width  / 2;
      var pinCY  = pRect.top  + pRect.height / 2;
      var pinR   = pRect.height / 2 + gap;
      var top, arrowClass;

      if (pinCY - pinR - ph > margin) {
        top = pinCY - pinR - ph; arrowClass = 'jhs-popup--arrow-down';
      } else if (pinCY + pinR + ph < vh - margin) {
        top = pinCY + pinR; arrowClass = 'jhs-popup--arrow-up';
      } else {
        top = Math.max(margin, Math.min(pinCY - ph / 2, vh - ph - margin));
        arrowClass = pinCX > vw / 2 ? 'jhs-popup--arrow-right' : 'jhs-popup--arrow-left';
      }

      var left = pinCX - pw / 2;
      if (left < margin)           left = margin;
      if (left + pw > vw - margin) left = vw - pw - margin;

      popup.style.top   = top  + 'px';
      popup.style.left  = left + 'px';
      popup.style.width = pw   + 'px';

      popup.classList.remove('jhs-popup--arrow-up','jhs-popup--arrow-down','jhs-popup--arrow-left','jhs-popup--arrow-right');
      popup.classList.add(arrowClass);

      var arrow = popup.querySelector('.jhs-popup__arrow');
      if (arrow) {
        var isVert = arrowClass === 'jhs-popup--arrow-up' || arrowClass === 'jhs-popup--arrow-down';
        if (isVert) {
          arrow.style.removeProperty('top');
          arrow.style.left = Math.max(14, Math.min(pw - 26, pinCX - left - 6)) + 'px';
        } else {
          arrow.style.removeProperty('left');
          arrow.style.top = Math.max(14, Math.min(ph - 26, pinCY - top - 7)) + 'px';
        }
      }
    }

    function showPopup(pin) {
      if (openPopup) hidePopup(true);
      var pinId = pin.dataset.pinId;
      var popup = popupMap[pinId];
      var dot   = pin.querySelector('.jhs-dot');
      if (!popup || !dot) return;

      popup.style.opacity    = '0';
      popup.style.visibility = 'hidden';
      popup.style.transform  = 'scale(.9) translateY(10px)';
      popup.classList.add('jhs-popup--visible');
      popup.setAttribute('aria-hidden', 'false');

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          positionPopup(popup, pin);
          popup.style.opacity    = '';
          popup.style.visibility = '';
          popup.style.transform  = '';
        });
      });

      dot.setAttribute('aria-expanded', 'true');
      backdrop.classList.add('jhs-backdrop--active');
      openPopup = { popup: popup, pin: pin, dot: dot };

      var closeBtn = popup.querySelector('.jhs-popup__close');
      if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 350);
    }

    function hidePopup() {
      if (!openPopup) return;
      openPopup.popup.classList.remove('jhs-popup--visible');
      openPopup.popup.setAttribute('aria-hidden', 'true');
      openPopup.dot.setAttribute('aria-expanded', 'false');
      backdrop.classList.remove('jhs-backdrop--active');
      openPopup = null;
    }

    section.querySelectorAll('.jhs-pin').forEach(function (pin) {
      pin.querySelector('.jhs-dot').addEventListener('click', function (e) {
        e.stopPropagation();
        if (openPopup && openPopup.pin === pin) hidePopup();
        else showPopup(pin);
      });
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.jhs-popup__close')) { hidePopup(); return; }
      if (e.target === backdrop) { hidePopup(); return; }

      var cta = e.target.closest && e.target.closest('.jhs-popup__cta');
      if (cta) {
        e.preventDefault();
        var vid = cta.dataset.variantId;
        if (!vid || cta.disabled) return;
        cta.disabled = true;
        var origHTML = cta.querySelector('.jhs-popup__cta-label').innerHTML;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: vid, quantity: 1 })
        })
        .then(function (res) {
          if (res.ok) {
            cta.classList.add('jhs-added');
            cta.querySelector('.jhs-popup__cta-label').innerHTML =
              '<svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M5 13l4 4L19 7"/></svg> Añadido';
            document.dispatchEvent(new CustomEvent('cart:refresh',    { bubbles: true }));
            document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));
            setTimeout(function () {
              cta.querySelector('.jhs-popup__cta-label').innerHTML = origHTML;
              cta.classList.remove('jhs-added');
              cta.disabled = false;
            }, 2600);
          } else { cta.disabled = false; }
        })
        .catch(function () { cta.disabled = false; });
        return;
      }

      if (openPopup &&
          !(e.target.closest && e.target.closest('.jhs-popup')) &&
          !(e.target.closest && e.target.closest('.jhs-dot'))) {
        hidePopup();
      }
    });

    window.addEventListener('scroll', function () { if (openPopup) positionPopup(openPopup.popup, openPopup.pin); }, { passive: true });
    window.addEventListener('resize', function () { if (openPopup) positionPopup(openPopup.popup, openPopup.pin); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openPopup) { openPopup.dot.focus(); hidePopup(); }
    });

    /* ─── Posición responsive de pins ─── */
    function applyPinPositions() {
      var isMob = window.innerWidth <= 767;
      section.querySelectorAll('.jhs-pin').forEach(function (pin) {
        var x = isMob ? pin.dataset.pxMobile  : pin.dataset.pxDesktop;
        var y = isMob ? pin.dataset.pyMobile  : pin.dataset.pyDesktop;
        pin.style.setProperty('--px', x + '%');
        pin.style.setProperty('--py', y + '%');
      });
    }
    applyPinPositions();

    /* Re-aplicar en resize (throttled) */
    var resizePinTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizePinTimer);
      resizePinTimer = setTimeout(applyPinPositions, 80);
    }, { passive: true });

    initParallax(section);
  }

  document.querySelectorAll('.jhs').forEach(initHotspots);
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.jhs');
    if (s) initHotspots(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
